import React, { createContext, useState } from "react";

interface ChangePasswordActionContextType {
  userId: number | null;
  setUserId: (id: number | null) => void;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (e: any) => void;
  formData: { password: string; password_confirmation: string };
  setFormData: (d: { password: string; password_confirmation: string }) => void;
}

export const ChangePasswordActionContext = createContext<ChangePasswordActionContextType>({
  userId: null,
  setUserId: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: null,
  setBackendFormErrors: () => {},
  formData: { password: "", password_confirmation: "" },
  setFormData: () => {},
});

export const ChangePasswordActionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userId, setUserId] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState<any>(null);
  const [formData, setFormData] = useState({ password: "", password_confirmation: "" });

  const value = {
    userId,
    setUserId,
    showModal,
    setShowModal,
    backendFormErrors,
    setBackendFormErrors,
    formData,
    setFormData,
  };
  return <ChangePasswordActionContext.Provider value={value}>{children}</ChangePasswordActionContext.Provider>;
};

